import { SavedCard } from '../WalletSavedCardsSection.types';

export const walletSavedCardsSectionMock: SavedCard[] = [
  {
    id: 'card-1',
    cardNumber: '1234',
    cardholderName: 'John Doe',
    cardType: 'VISA',
    expiryDate: '12/25',
    isPrimary: true,
    cardStatus: 'ACTIVE',
  },
];
